import { Tag } from "@/services/tags.service";

export type TagSortMode = "recent" | "alphabetical" | "count";

export function sortTags<T extends Tag>(tags: T[], mode: TagSortMode = "recent"): T[] {
  const tagsCopy = [...tags];

  switch (mode) {
    case "recent":
      return tagsCopy.sort((a, b) => {
        if (!a.lastUsedAt && !b.lastUsedAt) return a.name.localeCompare(b.name);
        if (!a.lastUsedAt) return 1;
        if (!b.lastUsedAt) return -1;
        return new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime();
      });

    case "count":
      return tagsCopy.sort((a, b) => {
        const countA = (a as T & { count?: number }).count ?? 0;
        const countB = (b as T & { count?: number }).count ?? 0;
        if (countA !== countB) return countB - countA;
        return a.name.localeCompare(b.name);
      });

    case "alphabetical":
    default:
      return tagsCopy.sort((a, b) => a.name.localeCompare(b.name));
  }
}

